import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import Chip, { ChipProps } from '@mui/material/Chip';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { Box, Divider, Flex, FormControls } from '@atoms/layout';
import { Button } from '@atoms/buttons';
import { DelayedLinearProgress } from '@molecules/feedback';

type SettingsFormProps = {
  title: ReactNode;
  subtitle: ReactNode;
  message?: ReactNode;
  messageType?: ChipProps['color'];
  parts?: ReactNode[];
  loading?: boolean;
  onCancel?: () => void;
};
export function SettingsForm(props: SettingsFormProps) {
  const theme = useTheme();
  const { title, subtitle, message, parts, messageType, loading = false, onCancel } = props;
  return (
    <Box>
      <DelayedLinearProgress show={loading} />
      <Box p={3}>
        <Flex gap={2} alignCenter>
          <Typography variant="h5">{title}</Typography>
          {message && <Chip label={message} color={messageType} size="small" />}
        </Flex>
        <Box mt={1}>
          <Typography variant="body1" color="text.secondary">
            {subtitle}
          </Typography>
        </Box>
        <Divider />
        <Stack divider={<Divider />}>{parts?.map((part, index) => <Box key={index}>{part}</Box>)}</Stack>
      </Box>
      <Box position="sticky" bottom="0px" bgcolor={theme.palette.background.paper}>
        <Divider sx={{ my: 0 }} />
        <FormControls>
          <Button color="inherit" size="large" rounded onClick={() => onCancel?.()}>
            <FormattedMessage id="common.cancel" />
          </Button>
          <Button variant="contained" color="primary" type="submit" size="large" disabled={loading} rounded>
            <FormattedMessage id="common.saveChanges" />
          </Button>
        </FormControls>
      </Box>
    </Box>
  );
}
